import apiClient from '@/services/api-client';


export const saveCinFullData = async (rectoFile, versoFile, dto ) => {
  const formData = new FormData();
  formData.append('recto-file', rectoFile);
  formData.append('verso-file', versoFile);
  formData.append('dto', new Blob([JSON.stringify(dto)], { type: 'application/json' }));

  const response = await apiClient.post('/collect-data/cin-full', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return response.data; 
};

export const saveCinRectoData = async (file, cinRecto) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('dto', new Blob([JSON.stringify(cinRecto)], { type: 'application/json' }));

  const response = await apiClient.post('/collect-data/cin-recto', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return response.data;
};

export const savePassportData = async (file, passport) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('dto', new Blob([JSON.stringify(passport)], { type: 'application/json' }));

  const response = await apiClient.post('/collect-data/passport', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return response.data;
};

export const getAllData = async (params = {}) => {
  const response = await apiClient.get('/collect-data/list', { params });
  return response.data;
};

export const getDocumentById = async (id) => {
  const response = await apiClient.get('/collect-data/details/'+id);
  return response.data;
};

export const updateDocument = async (document) => {
  const response = await apiClient.post('/collect-data/update/document', document);
  return response.data;
};
